import { Injectable } from "@angular/core";

@Injectable()
export class TrackerService {
  public track(event: string) {
    // dataLayer is used to pass data to GTM
    // https://developers.google.com/tag-manager/devguide#datalayer
    if (typeof window.dataLayer === "undefined" || window.dataLayer === null) {
      return;
    }
    window.dataLayer.push({ event });
  }
}
